import React from 'react';
import {Link} from 'react-router-dom';
import {formatDate, formatTime} from '../../utils/dateTime';
import {downloadExcel, printPDF} from '../../utils/printUtils';

const Header = ({title, cb, tableData, type = 'inpatient'}) => {
  // const headers = ['Patient Name', 'Procedure', 'Hospital', 'Date', 'Time', 'Paid In', 'Amount', 'Status'];

  const headers = {
    patient: 'Patient Name',
    procedure: 'Procedure',
    hospital: 'Hospital',
    admission_date: 'Date',
    Time: 'Time',
    payment_at: 'Paid In',
    amount: 'Amount',
    status: 'Status'
  };

  const transformedData = tableData.map(item => {
    const date = formatDate(item.admission_date);
    const time = formatTime(item.admission_date);
    return {
      ...item,
      admission_date: date, // Store only the date
      Time: time // Add a new key for time
    };
  });

  const handlePrintPdf = () => {
    const data = transformedData;
    printPDF({title, headers, data});
  };
  const handleDownload = () => {
    const data = transformedData;

    downloadExcel({title, headers, data});
  };

  return (
    <div className='patient-header'>
      <div className='row'>
        <div className='col'>
          <h3 className='page-title'>{title}</h3>
          <ul className='breadcrumb'>
            <li className='breadcrumb-item'>
              <a href='/' style={{textDecoration: 'none', color: 'black'}}>
                Dashboard
              </a>
            </li>
            <Link to='/inpatient' className='btn_1 text-decoration-none breadcrumb-item active'>
              Inpatient Schedule
            </Link>
            {type === 'view' && <li className='breadcrumb-item active'>View Schedule</li>}
          </ul>
        </div>
      </div>
      {type === 'inpatient' ? (
        <div className='add_btn' style={{display: 'flex', gap: '10px'}}>
          <button onClick={cb} className='btn_1'>
            Add
          </button>
          <Link to='/inpatient/view' className='btn_1 text-decoration-none'>
            View
          </Link>
        </div>
      ) : (
        <div className='add_btn' style={{display: 'flex', gap: '10px'}}>
          <button onClick={handleDownload} className='btn_1'>
            Download
          </button>
          <button onClick={handlePrintPdf} className='btn_1'>
            Print
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
